import { Navigate, Outlet } from "react-router-dom";

const PublicRoute = ({ children }: { children?: JSX.Element }) => {
  const token = localStorage.getItem("token");

  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData :any = null;
  userData = rawUserData ? JSON.parse(rawUserData) :null;

  if (token && userData) {
    return <Navigate to="/dashboard" replace />;
  }

  // if single child (like your previous usage)
  if (children) return children;

  // if used as wrapper with Outlet
  return <Outlet />;
};

export default PublicRoute;
